import { render } from "./UnitTypes.vue?vue&type=template&id=04abbef7&scoped=true"
import script from "./UnitTypes.vue?vue&type=script&lang=js"
export * from "./UnitTypes.vue?vue&type=script&lang=js"

import "./UnitTypes.vue?vue&type=style&index=0&id=04abbef7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04abbef7"]])

export default __exports__